import React, { Component } from 'react';

class ResultadoOperacion extends Component {
    render() { 

        const {data,actions,resultado} = this.props;

        let tituloModal = "Operación finalizada"
        let mensajeSuperior = "";

        if(resultado){
            mensajeSuperior = "La operación se realizó exitosamente";
        }else{
            mensajeSuperior = "Hubo un error en la comunicación con la procesadora, por favor intente nuevamente más tarde";
        }

        return (  
        <div className='modalIntegrantesInterior'>
            <div>
                {tituloModal}
            </div>
            <div className='modaReimpresionTarjetaCuerpo'>
                <div>{mensajeSuperior}</div>
               
            </div>
            <div className='modaConfirmadorBloqueoInteriorFooter'>
                <button onClick={()=>actions.modalSeccion("IntegrantesCuenta","PIN-RESULTADO",false,null,"resultadoOperacion")} className='btn btn-secondary'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default ResultadoOperacion;